export default "__VITE_ASSET__6161ccf1__"